module.exports = __webpack_public_path__ + "static/paris-011.thumb-59777902539a09ce626a672187df2c2d.jpg";